export default __webpack_public_path__ + "static/media/hero-bundle.54426281.png";